/** @jsxImportSource theme-ui */
import { useSelector, useDispatch } from "react-redux";
import { selectUIVersion, selectSelectedProduct } from "store/app";
import { Box, Text, useThemeUI, Button } from "theme-ui";
import { useEffect } from "react";
import { useAnimation, motion } from "framer-motion";

import { ProductLogos } from "components";
import { CloseIcon } from "components/icons";
import * as styles from "./AppLayout.styles";
import { displayModal } from "store/app/appSlice";

export default function AppLayout({
  hasLoadedSelectedProduct,
  appTitle,
  appLogo,
  productLogo,
  variantLogo,
  closeAppLink,
  children,
  isDisplayingModals,
  ...props
}) {
  const {
    theme: { isMobile },
  } = useThemeUI();

  const UIVersion = useSelector(selectUIVersion);

  const controls = useAnimation();
  const selectedProduct = useSelector(selectSelectedProduct);
  const dispatch = useDispatch();

  useEffect(() => {
    controls.start({
      height: hasLoadedSelectedProduct
        ? isMobile
          ? "calc(50% + 30px)"
          : "180px"
        : "0px",
      transition: {
        duration: 0.3,
        delay: hasLoadedSelectedProduct ? 0.5 : 0,
      },
    });
  }, [hasLoadedSelectedProduct]);

  return (
    <>
      <Box sx={styles.appLayout({ isDisplayingModals })} {...props}>
        {UIVersion === 1 && appLogo?.url && (
          <Box sx={styles.appHeader}>
            <ProductLogos
              appLogo={appLogo}
              productLogo={productLogo}
              variantLogo={variantLogo}
            >
              {appTitle && <Text variant="h5Light">{appTitle}</Text>}
            </ProductLogos>
          </Box>
        )}

        {closeAppLink && UIVersion === 1 && (
          <Button
            variant="unstyled"
            sx={styles.closeButton}
            onClick={
              selectedProduct
                ? () =>
                    dispatch(
                      displayModal({
                        modal: "LeaveAppModal",
                      })
                    )
                : () => (window.location.href = closeAppLink)
            }
          >
            <CloseIcon strokeWidth="10" stroke="##00000" />
          </Button>
        )}
        {children}
      </Box>

      <motion.div sx={styles.bottomShadow} animate={controls} />
    </>
  );
}
